import { render, staticRenderFns } from "./RecommendJobDetailPanel.vue?vue&type=template&id=a89b548a&scoped=true"
import script from "./RecommendJobDetailPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendJobDetailPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RecommendJobDetailPanel.vue?vue&type=style&index=0&id=a89b548a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89b548a",
  null
  
)

export default component.exports